import { createFileRoute } from '@tanstack/react-router';
import { TravelAdmin } from '@/features/travel/TravelAdmin';

export const Route = createFileRoute('/_app/admin/travel-policies')({ component: TravelAdmin });

// Admin policy trasferte: travel-policies / travel-policy-tiers (CRUD JSON:API, massimali informativi).
